export default class collisionsWorkPeriodController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, error
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.error = error;

    this.dates = [];
    if (angular.isDefined(this.error.WorkDaysCannotBeEdited.dates) && this.error.WorkDaysCannotBeEdited.dates.length > 0) {
      this.error.WorkDaysCannotBeEdited.dates.forEach(date => {
        this.dates.push(date);
      });
    }

    if (angular.isDefined(this.error.WorkDaysCannotBeRemoved.dates) && this.error.WorkDaysCannotBeRemoved.dates.length > 0) {
      this.error.WorkDaysCannotBeRemoved.dates.forEach(date => {
        this.dates.push(date);
      });
    }
  }

  cancel() {
    return this.$mdDialog.cancel();
  }

  hide(canEdit) {
    if (canEdit) {
      return this.$mdDialog.hide(this.dates);
    }

    return this.$mdDialog.hide(canEdit);
  }
}
